/**
 * @fileoverview gRPC-Web generated client stub for wisetime.user.notification.v4
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.14.0
// source: wisetime/user/notification/v4/notification.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as wisetime_user_notification_v4_notification_pb from '../../../../wisetime/user/notification/v4/notification_pb';


export class NotificationServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorListNotifications = new grpcWeb.MethodDescriptor(
    '/wisetime.user.notification.v4.NotificationService/ListNotifications',
    grpcWeb.MethodType.UNARY,
    wisetime_user_notification_v4_notification_pb.ListNotificationsRequest,
    wisetime_user_notification_v4_notification_pb.ListNotificationsResponse,
    (request: wisetime_user_notification_v4_notification_pb.ListNotificationsRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_notification_v4_notification_pb.ListNotificationsResponse.deserializeBinary
  );

  listNotifications(
    request: wisetime_user_notification_v4_notification_pb.ListNotificationsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_notification_v4_notification_pb.ListNotificationsResponse>;

  listNotifications(
    request: wisetime_user_notification_v4_notification_pb.ListNotificationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_notification_v4_notification_pb.ListNotificationsResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_notification_v4_notification_pb.ListNotificationsResponse>;

  listNotifications(
    request: wisetime_user_notification_v4_notification_pb.ListNotificationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_notification_v4_notification_pb.ListNotificationsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.notification.v4.NotificationService/ListNotifications',
        request,
        metadata || {},
        this.methodDescriptorListNotifications,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.notification.v4.NotificationService/ListNotifications',
    request,
    metadata || {},
    this.methodDescriptorListNotifications);
  }

  methodDescriptorAckNotification = new grpcWeb.MethodDescriptor(
    '/wisetime.user.notification.v4.NotificationService/AckNotification',
    grpcWeb.MethodType.UNARY,
    wisetime_user_notification_v4_notification_pb.AckNotificationRequest,
    wisetime_user_notification_v4_notification_pb.AckNotificationResponse,
    (request: wisetime_user_notification_v4_notification_pb.AckNotificationRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_notification_v4_notification_pb.AckNotificationResponse.deserializeBinary
  );

  ackNotification(
    request: wisetime_user_notification_v4_notification_pb.AckNotificationRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_notification_v4_notification_pb.AckNotificationResponse>;

  ackNotification(
    request: wisetime_user_notification_v4_notification_pb.AckNotificationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_notification_v4_notification_pb.AckNotificationResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_notification_v4_notification_pb.AckNotificationResponse>;

  ackNotification(
    request: wisetime_user_notification_v4_notification_pb.AckNotificationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_notification_v4_notification_pb.AckNotificationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.notification.v4.NotificationService/AckNotification',
        request,
        metadata || {},
        this.methodDescriptorAckNotification,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.notification.v4.NotificationService/AckNotification',
    request,
    metadata || {},
    this.methodDescriptorAckNotification);
  }

}

